import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { Close, UploadFile } from '@mui/icons-material';

import { uploadCurrentEmploymentFile } from '../../../../actions/employmentsActions';
import { getSignedFileUrl } from '../../../../actions/utilsActions';

const styles = {
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  item: {
    my: '0.5rem'
  },
  divider: {
    py: '0.5rem'
  }
}

const EmployeeDetailsFileDialog = props => {
  const [file, setFile] = useState(null);
  const [signedUrl, setSignedUrl] = useState(null);

  const params = useParams();
  const employment = useSelector(state => state.employments.list[0]);
  const dispatch = useDispatch();

  const handleFileChange = e => setFile(e.target.files[0]);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      if (!employment?.fileUrl) {
        setSignedUrl(null);
        return;
      }
      try {
        const url = await dispatch(getSignedFileUrl({ query: employment.fileUrl })).unwrap();
        setSignedUrl(url);
      } catch (err) {
        setSignedUrl(null);
      }
    };

    fetchSignedUrl();
  }, [employment?.fileUrl, dispatch]);

  const handleClose = () => {
    setFile(null);
    props.onClose();
  }

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(uploadCurrentEmploymentFile({ id: employment._id, employeeId: params.id, file }));
    props.onClose();
  }

  return (
    <Dialog open={props.open} onClose={handleClose} maxWidth={false}>
      <DialogTitle sx={styles.title}>
        Archivo del empleado
        <IconButton onClick={handleClose}><Close /></IconButton>
      </DialogTitle>
      <DialogContent sx={styles.content}>
        {employment?.fileUrl ? (
          signedUrl ? (
            <a href={signedUrl} target="_blank" rel="noreferrer">Abrir archivo</a>
          ) : (
            <Typography>Cargando enlace…</Typography>
          )
        ) : (
          <Typography>Sin archivo</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <IconButton component="label">
          <UploadFile /><input type="file" hidden={true} accept="application/pdf" onChange={handleFileChange} />
        </IconButton>
        <Button variant="text" disabled={!file} onClick={handleSubmit}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default EmployeeDetailsFileDialog;
